import React from 'react';

export const NAV_ITEMS = [
  { id: 'nav-work', label: 'Work', href: '#work' },
  { id: 'nav-about', label: 'About', href: '#about' },
  { id: 'nav-references', label: 'References', href: '#references' },
  { id: 'nav-contact', label: 'Contact', href: '#contact' },
];

export function DesktopNav() {
  return (
    <nav className="hidden md:flex items-center gap-9">
      {NAV_ITEMS.map((n) => (
        <a
          key={n.id}
          href={n.href}
          className="nav-link text-[13px] uppercase tracking-[0.22em] text-cream"
        >
          {n.label}
        </a>
      ))}
    </nav>
  );
}

export function MobileNav({ onClose }) {
  return (
    <div className="md:hidden border-t border-cream bg-navy/95 backdrop-blur-md">
      <div className="flex flex-col px-6 py-6 gap-5">
        {NAV_ITEMS.map((n) => (
          <a
            key={n.id}
            href={n.href}
            className="text-cream text-sm uppercase tracking-[0.25em]"
            onClick={onClose}
          >
            {n.label}
          </a>
        ))}
        <a
          href="#contact"
          onClick={onClose}
          className="btn-orange text-center px-5 py-3 text-xs uppercase tracking-[0.2em] rounded-full"
        >
          Say hello
        </a>
      </div>
    </div>
  );
}
